export default "<div class=\"first-row\">\n    <iframe [src]='url'></iframe>\n</div>"